import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { TranslateModule } from '@ngx-translate/core';
import { VideoPlayerComponent } from './video-player/video-player';
import { NotificationComponent } from './notification/notification';
import { AssetComponent } from './asset/asset';
import { CategoryComponent } from './category/category';
import { LanguageFilterComponent } from './language-filter/language-filter';
import { AudienceFilterComponent } from './audience-filter/audience-filter';
import { OrderbyFilterComponent } from './orderby-filter/orderby-filter';
import { IndicationFilterComponent } from './indication-filter/indication-filter';
import { LocalFileComponent } from './local-file/local-file';

@NgModule({
	declarations: [VideoPlayerComponent,
    NotificationComponent,
    AssetComponent,
    CategoryComponent,
    LanguageFilterComponent,
    AudienceFilterComponent,
    OrderbyFilterComponent,
    IndicationFilterComponent,
    LocalFileComponent],
	imports: [
		IonicModule,
        TranslateModule.forChild()
	],
	exports: [VideoPlayerComponent,
    NotificationComponent,
    AssetComponent,
    CategoryComponent,
    LanguageFilterComponent,
    AudienceFilterComponent,
    OrderbyFilterComponent,
    IndicationFilterComponent,
    LocalFileComponent],
    entryComponents: []
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts